/**
 * Falla de red (sin respuesta del servidor: sin internet, servidor caído, CORS).
 * Axios la reporta como «Network Error», en inglés y sin contexto para el usuario.
 */
export const NETWORK_ERROR_MESSAGE = 'Revisa tu conexión e intenta de nuevo.';

export function isNetworkError(error: unknown): boolean {
    if (!error || typeof error !== 'object') return false;
    const candidate = error as { response?: unknown; code?: string; message?: string };
    if (candidate.response) return false;
    return candidate.code === 'ERR_NETWORK' || candidate.message === 'Network Error' || candidate.message === NETWORK_ERROR_MESSAGE;
}

/** Cambia el mensaje de una falla de red por uno en español; los demás errores no se tocan. */
export function localizeNetworkError<T>(error: T): T {
    if (isNetworkError(error)) (error as { message: string }).message = NETWORK_ERROR_MESSAGE;
    return error;
}
